import React from 'react';

const AboutPatchifi = () => {
  const highlightStyle = {
    color: '#ef4444',
    fontWeight: '600',
  };

  return (
    <div
      style={{
        backgroundColor: '#1a1a1a',
        color: '#e5e5e5',
        padding: '20px',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
        minHeight: '100vh',
      }}
    >
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        <h2
          style={{
            fontSize: '28px',
            fontWeight: '400',
            marginBottom: '30px',
            color: '#ffffff',
            letterSpacing: '0.5px',
          }}
        >
          About Patchifi
        </h2>

        <div
          style={{
            backgroundColor: '#242424',
            border: '1px solid #333333',
            borderRadius: '8px',
            padding: '40px',
            marginBottom: '30px',
          }}
        >
          <p
            style={{
              fontSize: '18px',
              lineHeight: '1.8',
              marginBottom: '24px',
              color: '#d4d4d4',
            }}
          >
            <strong style={highlightStyle}>Patchifi</strong> is an innovative{' '}
            <strong style={highlightStyle}>autonomous endpoint management</strong> and{' '}
            <strong style={highlightStyle}>patch orchestration</strong> platform designed to simplify vulnerability remediation at scale.
          </p>

          <p
            style={{
              fontSize: '18px',
              lineHeight: '1.8',
              marginBottom: '24px',
              color: '#d4d4d4',
            }}
          >
            It enables IT and security teams to automatically <strong style={highlightStyle}>detect, prioritize, test</strong>, and{' '}
            <strong style={highlightStyle}>deploy</strong> operating system and third-party application patches—while maintaining minimal
            downtime and optimizing compliance in modern hybrid environments.
          </p>

          <p
            style={{
              fontSize: '18px',
              lineHeight: '1.8',
              color: '#d4d4d4',
            }}
          >
            With built-in <strong style={highlightStyle}>real-time visibility, integration into IT service workflows</strong>, and{' '}
            <strong style={highlightStyle}>policy-driven automation</strong>, Patchifi helps organizations enhance endpoint security,
            streamline patch compliance, and reduce operational cost.
          </p>
        </div>

        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
            gap: '20px',
          }}
        >
          <div
            style={{
              backgroundColor: '#242424',
              border: '1px solid #333333',
              borderRadius: '8px',
              padding: '24px',
            }}
          >
            <h3
              style={{
                fontSize: '16px',
                fontWeight: '500',
                marginBottom: '12px',
                color: '#ffffff',
              }}
            >
              Automated Detection
            </h3>
            <p
              style={{
                fontSize: '14px',
                lineHeight: '1.6',
                color: '#a3a3a3',
              }}
            >
              Continuously scan and identify vulnerabilities across all endpoints in real-time.
            </p>
          </div>

          <div
            style={{
              backgroundColor: '#1a1a1a',
              border: '1px solid #2a2a2a',
              borderRadius: '8px',
              padding: '24px',
            }}
          >
            <h3
              style={{
                fontSize: '16px',
                fontWeight: '500',
                marginBottom: '12px',
                color: '#ffffff',
              }}
            >
              Smart Orchestration
            </h3>
            <p
              style={{
                fontSize: '14px',
                lineHeight: '1.6',
                color: '#a3a3a3',
              }}
            >
              Intelligently prioritize and deploy patches with minimal business disruption.
            </p>
          </div>

          <div
            style={{
              backgroundColor: '#1a1a1a',
              border: '1px solid #2a2a2a',
              borderRadius: '8px',
              padding: '24px',
            }}
          >
            <h3
              style={{
                fontSize: '16px',
                fontWeight: '500',
                marginBottom: '12px',
                color: '#ffffff',
              }}
            >
              Enhanced Security
            </h3>
            <p
              style={{
                fontSize: '14px',
                lineHeight: '1.6',
                color: '#a3a3a3',
              }}
            >
              Strengthen your security posture with comprehensive patch compliance.
            </p>
          </div>

          <div
            style={{
              backgroundColor: '#1a1a1a',
              border: '1px solid #2a2a2a',
              borderRadius: '8px',
              padding: '24px',
            }}
          >
            <h3
              style={{
                fontSize: '16px',
                fontWeight: '500',
                marginBottom: '12px',
                color: '#ffffff',
              }}
            >
              Real-Time Insights
            </h3>
            <p
              style={{
                fontSize: '14px',
                lineHeight: '1.6',
                color: '#a3a3a3',
              }}
            >
              Monitor patch status and compliance across your entire infrastructure.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutPatchifi;
